import { getUserAgent } from './ssrCompatible'
import { isInCoinsApp, getQuery } from '@/utils/utils'
import { isMsaWebView } from '@/utils/msa'
import { isPwa } from '@/utils/utils'

export const isMobile = () => {
  const userAgent = getUserAgent()

  return userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}

export const isIphone = () => {
  const userAgent = getUserAgent()
  return /iPad|iPhone|iPod/.test(userAgent)
}

export const isIphoneX = () => {
  return !!(process.client && isIphone() && window.screen.height >= 812)
}

export const isHeightLessThan750 = () => {
  return !!(process.client && window.screen.height <= 750)
}

export const customMadeQuery = () => {
  return getQuery('source') === 'PrdTest6'
}

/**
 * 获取平台
 * @returns APP/GT/PWA/H5/PC
 */
export const platformType = () => {
  const is_mobile = !!isMobile()
  const is_turbo = getQuery('mode') === 'gt' && is_mobile
  const is_pwa = !!isPwa()
  const is_desktop = !is_mobile

  // 注：判断是有优先级的，如果要调整顺序请及时沟通
  if (isInCoinsApp()) return 'APP' // App
  if (isMsaWebView()) return 'GT' // msa弹窗-webview返回GT
  if (is_turbo) return 'GT' // 小窗
  if (is_pwa) return 'PWA' // pwa
  if (is_mobile) return 'H5' // 是否是移动端
  if (is_desktop) return 'PC' // 是否为桌面设备
  return 'unkown' // 如果都不是，则返回未知
}

// 检测屏幕方向
export const checkOrient = () => {
  // landscape是横向，portrait是纵向
  const portrait = 'portrait'
  const landscape = 'landscape'
  if (!process.client) {
    return portrait
  }
  if (window.orientation == 0 || window.orientation == 180) {
    return portrait
  } else if (window.orientation == 90 || window.orientation == -90) {
    return landscape
  }
  // css属性检测
  const portraitMatch = window.matchMedia('(orientation: portrait)')
  if (portraitMatch.matches) {
    return portrait
  }
  const landscapeMatch = window.matchMedia('(orientation: landscape)')
  if (landscapeMatch.matches) {
    return landscape
  }
  // 宽高比
  const height = window.innerHeight
  const width = window.innerWidth
  if (width > height) {
    return landscape
  }

  return portrait
}

export const isHorizontalScreen = () => {
  if (!process.client) {
    return false
  }
  const screenOrientation = checkOrient()
  return screenOrientation === 'landscape'
}

/**
 * 根据宽高比判断是横向还是纵向
 * @returns
 */
export const isHorizontalWithInner = () => {
  if (!process.client) return false
  // 设备方向
  if (window.orientation == 0 || window.orientation == 180) return false
  // css属性检测
  const portraitMatch = window.matchMedia('(orientation: portrait)')
  if (portraitMatch.matches) return false
  // 设备横向时，根据宽高比检测
  const height = window.innerHeight
  const width = window.innerWidth
  return width > height
}
